module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 17.552 17.301",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#calendar",
      toString: function () {
        return this.url;
      }
    }